module.exports = __webpack_public_path__ + "img/master_logo.4b10fe4f.png";